import React from "react";
import LawFirmBondsPage from "./components/LawFirmBondsPage";
import { LAW_FIRM_BONDS_MODES } from "./helpers/lawFirmBondsPageConfig";

const LawFirmEndorseBonds = () => (
  <LawFirmBondsPage mode={LAW_FIRM_BONDS_MODES.ENDORSE} />
);

export default LawFirmEndorseBonds;
